import { render } from "./DeleteDepartmentUser.vue?vue&type=template&id=11b25bca&scoped=true"
import script from "./DeleteDepartmentUser.vue?vue&type=script&lang=js"
export * from "./DeleteDepartmentUser.vue?vue&type=script&lang=js"

import "./DeleteDepartmentUser.vue?vue&type=style&index=0&id=11b25bca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b25bca"]])

export default __exports__